import { useMemo } from "react";

import { TimeSlotButtonProps } from "@models/components/booking.model";
import { mergeClassNames } from "@utils/common.utils";

const TimeSlotButton = ({
  disabled,
  onClick,
  selectedTime,
  time,
}: TimeSlotButtonProps) => {
  const className = useMemo(
    () =>
      mergeClassNames(
        "btn fg-btn fg-btn-small",
        disabled ? "disabled" : "",
        selectedTime === time ? "active" : ""
      ),
    [disabled, selectedTime, time]
  );

  return (
    <button className={className} onClick={onClick}>
      {time}
    </button>
  );
};

export default TimeSlotButton;
